(function () {
  if (window.__hcsCartImgDeferBound) return;
  window.__hcsCartImgDeferBound = true;

  // PERF-04: recommendation images inside the closed cart drawer, the cart
  // notification popup, and the /cart page's hidden empty-state grid all sit
  // in the DOM before they're visible. Native `loading="lazy"` still fetches
  // them near-instantly because these containers are positioned off-canvas
  // via CSS transform rather than removed from layout, which native lazy
  // thresholds don't account for. Markup carries `data-hcs-defer-src(set)`
  // instead of `src`/`srcset`; this hydrates them only once their container
  // is actually revealed.

  function hydrate(img) {
    var srcset = img.getAttribute('data-hcs-defer-srcset');
    var src = img.getAttribute('data-hcs-defer-src');
    if (srcset) img.srcset = srcset;
    if (src) img.src = src;
    img.removeAttribute('data-hcs-defer-src');
    img.removeAttribute('data-hcs-defer-srcset');
  }

  function isRevealed(img) {
    var drawer = img.closest('cart-drawer');
    if (drawer) return drawer.classList.contains('active');

    var notification = img.closest('#cart-notification');
    if (notification) return notification.classList.contains('active');

    var cartItems = img.closest('cart-items');
    if (cartItems) return cartItems.classList.contains('is-empty');

    return true;
  }

  function sweep(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    var candidates = root.matches && root.matches('img[data-hcs-defer-src], img[data-hcs-defer-srcset]')
      ? [root]
      : root.querySelectorAll('img[data-hcs-defer-src], img[data-hcs-defer-srcset]');
    for (var i = 0; i < candidates.length; i++) {
      if (isRevealed(candidates[i])) hydrate(candidates[i]);
    }
  }

  sweep(document);

  function handleMutations(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (mutation.type === 'attributes') {
        sweep(mutation.target);
      } else {
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType === 1) sweep(node);
        }
      }
    }
  }

  // Scope observation to the stable roots that actually hold deferred
  // images (cart-drawer, cart-notification, the /cart page's cart-items)
  // instead of document.body — a body-wide observer fires on every DOM
  // mutation site-wide, most of which have nothing to do with cart images.
  // This script loads via defer, so these roots already exist in markup
  // by the time it runs (cart-drawer / cart-notification render globally
  // in theme.liquid; cart-items is static markup on sections/main-cart-items.liquid).
  var ROOT_SELECTORS = ['cart-drawer', '#cart-notification', 'cart-items'];

  ROOT_SELECTORS.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (root) {
      if (root.__hcsImgDeferObserved) return;
      root.__hcsImgDeferObserved = true;
      var observer = new MutationObserver(handleMutations);
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    });
  });
})();
